<section class="container-wrapper">
    <h1 class="module-heading">{{ 'pages.external-systems.heading' | translate }}</h1>
    <div class="loading-spinner" *ngIf="loading">
      <mat-progress-spinner
        mode="indeterminate"
        diameter="20">
      </mat-progress-spinner>
    </div>
    <div *ngIf="!loading">
      <div class="row">
        <app-external-systems-select class="w-100" 
          [label]="'pages.external-systems.selectLabel' | translate"
          [placeholder]="'pages.external-systems.selectPlaceholder' | translate"
          [options]="connectors"
          (selectChange)="connectorChange($event)"
          [connector]="connector"
        ></app-external-systems-select>
        <form [formGroup]="externalSystemsForm">
            <app-form-input
              *ngIf="connector"
              [placeholder]="'pages.external-systems.inputPlaceholder' | translate"
              formControlName="userId"
              (keyup)="init()"
            ></app-form-input>
        </form>
      </div>
      <div class="row justify-end">
        <button class="bciti-button ml-10" 
          [ngClass]="processingSubmit ? 'bciti-button--disabled' : 'bciti-button--blue'" 
          (click)="submit()"
          *ngIf="connector && userId != ''"
          [disabled]="processingSubmit">
          <span class="submit-loader">{{ 'pages.external-systems.button.submit' | translate }} <mat-spinner diameter="20" *ngIf="processingSubmit"></mat-spinner></span>
        </button>
      </div>
      <div class="row justify-end lookup" *ngIf="lookupData || message">
        <ngx-json-viewer *ngIf="lookupData" [json]="lookupData"></ngx-json-viewer>
        <span *ngIf="message">{{ message }}</span>
      </div>
    </div>
</section>